module.exports = __webpack_public_path__ + "static/img/brand-second-4-1.8d7f8a05.png";